import {NodeParamChunk} from "../../chunks/types/NodeParamChunk";
import {getVarNameFromVarAssignmentChunk} from "./getVarNameFromVarAssignmentChunk";

export function getParamNameFromNodeParamChunk(
  nodeParamChunk: NodeParamChunk
): string {
  const {captures: {1: varAssignmentChunk}} = nodeParamChunk;
  return getVarNameFromVarAssignmentChunk(varAssignmentChunk);
}
